import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Resets window scroll position to the top on every client-side route change.
// Mounted once inside <BrowserRouter> in App.js so every navigation triggers it.
const ScrollToTop = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    // Use 'instant' so the new page never appears scrolled-down mid-transition.
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, [pathname, search]);
  return null;
};

export default ScrollToTop;
